import React from "react";
import { Fab, Tooltip } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

export default function CreateFromPersonButton(props) {
  const { onClick, disabled, size, tooltipText } = props;

  return (
    <Tooltip title={tooltipText || "Create from person record "}>
      <Fab
        size="small"
        disabled={disabled}
        color="secondary"
        aria-label="person-search"
        className={props.className ? props.className : ""}
        onClick={onClick}
      >
        <PersonSearchIcon style={{ fontSize: size }} />
      </Fab>
    </Tooltip>
  );
}
